import type { FC, RefObject } from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type IFieldReadinessSchema, type ILocationDetailsSchema, type IPersonalDetailsSchema } from '../helper';
import { ProfileHeaderSection, SummaryContainer } from '../styled';
import PrintLocation from './print.location';
import PrintPersonalInfo from './print.personalinfo';
import PrintReadinessInfo from './print.readinessinfo';

interface BIC {
	personalDetailsHookForm: UseFormReturn<IPersonalDetailsSchema>;
	locationDetailsHookForm: UseFormReturn<ILocationDetailsSchema>;
	fieldReadinessDetailsHookForm: UseFormReturn<IFieldReadinessSchema>;
	contentRef: RefObject<HTMLDivElement | null>;
}

const PrintSummary: FC<BIC> = ({
	personalDetailsHookForm,
	locationDetailsHookForm,
	fieldReadinessDetailsHookForm,
	contentRef,
}) => (
	<div style={{ height: 0, overflow: 'hidden' }}>
		<SummaryContainer
			ref={contentRef}
			className='pt-4'
		>
			<ProfileHeaderSection>
				<h3>Election Agent Volunteer Registration</h3>
			</ProfileHeaderSection>

			<PrintPersonalInfo hookForm={personalDetailsHookForm} />

			<PrintLocation hookForm={locationDetailsHookForm} />

			<PrintReadinessInfo hookForm={fieldReadinessDetailsHookForm} />
		</SummaryContainer>
	</div>
);

export default PrintSummary;
